<template>
  <BaseFieldWrapper
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"

    @click.native=""

    v-slot="{attrs}"
  >
    <div class="BaseToggleSwitch" v-bind="attrs">
      <div
        class="layer bg-success"
        :class="[
          {active: isActiveValue},
          isActiveValue ? 'bg-success' : 'bg-danger'
        ]"
        
        :style="{width}"
      ></div>

      <span
        class="el form-toggle-switch-el"
        :class="[isActiveValue && 'text-light', {active: isActiveValue, notActive: !isActiveValue}]"

        :data-switchvalue="active"
        
        :style="{width}"
        @click="$emit('input', active)"
      >
        <slot name="active"></slot>
      </span>
      <span
        class="el form-toggle-switch-el last"
        :class="[!isActiveValue && 'text-light', {active: !isActiveValue, notActive: isActiveValue}]"

        :data-switchvalue="inactive"
        
        :style="{width}"
        @click="$emit('input', inactive)"
      >
        <slot name="inactive"></slot>
      </span>
    </div>
  </BaseFieldWrapper>
</template>

<script>

import BaseFieldWrapper, { props } from "./FormFieldWrapper.vue"

export default {
  name: "base-toggle-switch",
  components: {
    BaseFieldWrapper,
  },
  props: {
    ...props,

    width: {
      type: String,
      required: true,
    },
    active: {
      type: [String, Boolean],
      required: true,
    },
    inactive: {
      type: [String, Boolean],
      required: true,
    },
  },
  created() {
    if (!this.value && this.value !== this.inactive) {
      this.$emit("input", this.inactive)
    } 
  },
  computed: {
    isActiveValue() {
      return this.value === this.active
    },
  },
}

</script>

<style scoped>

.BaseToggleSwitch {
  display: inline-flex;
  border-radius: 1px;
  position: relative;
  background-color: #f5f5f5;
}

.layer {
  position: absolute;
  height: 100%;
  padding: 0px 8px;
  border-radius: 1px;
  box-sizing: content-box;
  transform: translateX(100%);
  transition-duration: .2s;
}

.layer:hover {
  filter: brightness(1.1);
}

.active.layer {
  transform: translateX(0);
}

.el {
  position: relative;
  cursor: pointer;
  text-align: center;
  border-radius: 8px;
  padding: 8px;
  box-sizing: content-box;
  transition-duration: .2s;
  background-color: #f5f5f5;
}

.el:hover {
  background-color: #e6e6e6;
}

.el.active {
  background-color: transparent;
}

</style>
